export default "__VITE_ASSET__CvHVlGKq__"